import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03c2d520&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2d520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c2d520')) {
      api.createRecord('03c2d520', component.options)
    } else {
      api.reload('03c2d520', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03c2d520&scoped=true", function () {
      api.rerender('03c2d520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/printing/index.vue"
export default component.exports